export function binData(values: number[], binCount = 10) {
    if (values.length === 0) return [];
    const min = Math.min(...values);
    const max = Math.max(...values);
    if (min === max) {
        return [{ bin: `${min}`, count: values.length }];
    }
    const binSize = (max - min) / binCount;
    const bins = Array.from({ length: binCount }, (_, i) => {
        const start = min + i * binSize;
        const end = start + binSize;
        return {
            bin: `${start.toFixed(2)} - ${end.toFixed(2)}`,
            count: 0,
            start,
            end,
        };
    });
    values.forEach((v) => {
        let idx = Math.floor((v - min) / binSize);
        if (idx === binCount) idx = binCount - 1;
        bins[idx].count += 1;
    });
    return bins.map(({ bin, count }) => ({ bin, count }));
}
